import { render, staticRenderFns } from "./PropertyClientActionGrid.vue?vue&type=template&id=1654a547&"
import script from "./PropertyClientActionGrid.vue?vue&type=script&lang=js&"
export * from "./PropertyClientActionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports